import { Dispatch, SetStateAction } from 'react';
import {
    FormControl,
    FormControlLabel,
    FormLabel,
    Radio,
    RadioGroup,
    useTheme,
} from '@mui/material';

import { menuItems, menuTitle } from '../constants';
import { MenuOptionValue } from '../types';
interface MenuProps {
    selectedMenuOption: MenuOptionValue;
    setSelectedMenuOption: Dispatch<SetStateAction<MenuOptionValue>>;
    isLocalAdmin: boolean;
    isGlobalAdmin: boolean;
}

const Menu = ({
    selectedMenuOption,
    setSelectedMenuOption,
    isLocalAdmin,
    isGlobalAdmin,
}: MenuProps) => {
    const theme = useTheme();
    const isLocalAdminOnly = isLocalAdmin && !isGlobalAdmin;
    return (
        <FormControl sx={{ pr: 4 }}>
            <FormLabel
                sx={{
                    color: theme.palette.customColors.black,
                    '&.Mui-focused': {
                        color: theme.palette.customColors.black,
                    },
                }}
            >
                {menuTitle}
            </FormLabel>
            <RadioGroup
                value={selectedMenuOption}
                onChange={(e) => setSelectedMenuOption(e.target.value as MenuOptionValue)}
            >
                {menuItems.map(({ label, value }) => (
                    <FormControlLabel
                        disabled={
                            isLocalAdminOnly && value !== MenuOptionValue.RegionalKnowledgeFiles
                        }
                        key={value}
                        value={value}
                        control={
                            <Radio
                                size='small'
                                sx={{
                                    '&.Mui-checked': {
                                        color: theme.palette.customColors.purple,
                                    },
                                }}
                            />
                        }
                        label={label}
                    />
                ))}
            </RadioGroup>
        </FormControl>
    );
};

export default Menu;
